import { FormattedMessage, useIntl } from 'react-intl';

import { formatDurationUnit } from '../utils/formatDurationUnit';
import type { Period } from './types';

export interface ContractPeriodProps {
    contractPeriod: Period;
    highlightPeriod: boolean;
}

export function ContractPeriod(props: ContractPeriodProps) {
    const { contractPeriod, highlightPeriod } = props;
    const intl = useIntl();
    const durationWithUnit = `${contractPeriod.length} ${formatDurationUnit(contractPeriod.unit, intl, contractPeriod.length)}`;

    return (
        <>
            <FormattedMessage id='intl-msg:common-message.contracts.period' />{' '}
            {highlightPeriod ? <strong>{durationWithUnit}</strong> : durationWithUnit}
        </>
    );
}
